var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAntiLeak)?[_c('AntiLeak',{on:{"recover-layout":_vm.recoverLayout}})]:(_vm.initialized === true)?[_c(_vm.layoutType,{tag:"component"})]:_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }